<template>
    <div class="flex items-center h-full border-l border-gray-200 transition duration-300">
        <nio-datepicker
            class-name="w-34 bg-transparent p-6 pr-0 transition duration-300"
            :value="value"
            @input="$emit('input', $event)"
        />
        <nio-icon class="mr-6 text-gray-600" name="regular/calendar-3" />
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: null,
                required: true,
            },
        },
    };
</script>
